module.exports = __webpack_public_path__ + "static/images/search-glass.548747605da423c422126748968b9ab4.svg";